/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
// import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import HeaderHome from "./header-home"
import Footer from "./footer"
import GetInTouch from "./getintouch"
// import Hero from "../components/hero"
import PageTitle from "../components/page-title"
// import OverlayNav from "../components/overlay-nav"
import OverlayNavScrolly from "../components/overlay-nav-scrolly"
import MainNav from "../components/main-nav"

const Page = ({ children, variant }) => {

  let header
  let main_nav_colour = 'light'
  if (variant && variant ==='home') {
    // header = <HeaderHome />
    header = null
    main_nav_colour = 'dark'
  }
  else {
    header = <Header />
    // main_nav_colour = 'light'
  }

  return (
    <>

      {header}

      {/* <div className="main-nav not-mobile">
        <ul>
          <li><Link to="/our-services/">Our Services</Link></li>
          <li><Link to="/case-studies/">Work</Link></li>
          <li><Link to="/the-team/">Who We Are</Link></li>
          <li><Link to="/latest-news/">News</Link></li>
          <li><Link to="/about/">About</Link></li>
          <li><Link to="/contact/">Contact</Link></li>
        </ul>
      </div> */}

      <MainNav variant={main_nav_colour} />

      <OverlayNavScrolly />

      <main class="main-content">
        {children}
      </main>

      {/* <GetInTouch /> */}

      <Footer />
      
    </>
  )
}

// Page.propTypes = {
//   children: PropTypes.node.isRequired,
// }

export default Page
